import { appService } from "/app/src/services";
import { useConnections } from "/app/src/contexts/ConnectionsStatusContext";
import OrderBuilder from "../orderBuilder";
import OrderProcessor from "../orderProcessor";
import Epicor from "../epicor";
import Hue from "../hue";
import CycleCounts from "../cycleCounts";
import Variance from "../variance";
import Slack from "../slack";
import Displays from "../displays";
import DisabledCheck from "/app/src/components/generic/components/disabled";
import DataPush from "../dataPush";
import { App } from "/app/src/models";
import { useNumberId } from "/app/src/hooks/useNumberId";
import { useQuery } from "@tanstack/react-query";
import DataPull from "../dataPull";
import { useHandleNavigationError } from "/app/src/helpers/api";
import { useTranslation } from "react-i18next";

/**
 * Component for displaying spreadsheets
 */
export function Spreadsheets() {
  const { t } = useTranslation();
  return <div>{t("translation:spreadsheets")}</div>;
}

/**
 * Component to map the app name to the correct component
 */
export default function SingleApp() {
  const { appId } = useNumberId();
  const { powerPick, webServices } = useConnections();
  const handleNavigationError = useHandleNavigationError();
  const { data: app, isFetching } = useQuery({
    queryKey: ["app", appId],
    queryFn: () => {
      return appService.getSingle(appId).catch(() => {
        handleNavigationError();
      });
    },
    initialData: { app: {} },
    retry: false,
    select: (data: { app: App }) => data.app,
  });

  if (isFetching) return null;
  else {
    switch (app.name) {
      case "Order Builder":
        return (
          <DisabledCheck
            name="Order Builder"
            connections={[powerPick, webServices]}
          >
            <OrderBuilder app={app} />
          </DisabledCheck>
        );
      case "Order Processor":
        return (
          <DisabledCheck
            name="Order Processor"
            connections={[webServices, powerPick]}
          >
            <OrderProcessor app={app} />
          </DisabledCheck>
        );
      case "Epicor":
        return <Epicor app={app} />;
      case "Philips Hue":
        return <Hue />;
      case "Cycle Counts":
        return <CycleCounts app={app} />;
      case "Variance":
        return <Variance app={app} />;
      case "Slack":
        return <Slack app={app} />;
      case "Displays":
        return <Displays app={app} />;
      case "Data Push":
        return <DataPush app={app} />;
      case "Data Pull":
        return <DataPull app={app} />;
      case "CSV":
      case "XLSX":
        return <Spreadsheets />;
      default:
        return app.name;
    }
  }
}
